import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Parser from 'html-react-parser';
import 'tippy.js/dist/tippy.css';

function WelcomeHeader() {
  
  const [welcomeText, setWelcomeText] = useState('');

  const location = useLocation();
  const cleanedPath = location.pathname.endsWith('/')
    ? location.pathname.slice(0, -1).toLowerCase()
    : location.pathname.toLowerCase();

  let titleClass = "left-bottom-title";



  return (
    <>
      <section className={`welcome-header`}>
        <div className='container'>
          <>
            <div className='titlewrapper welcome-title'>
              <h1 className={`welcometext ${titleClass}`}>
                 ADMIN CENTRE
              </h1>
              <svg role="presentation" viewBox="0 0 28 95" preserveAspectRatio="none">
                <path d="M28 47.5L-2.08616e-07 95L-2.08616e-07 0L28 47.5Z" fill="#738faf"></path>
              </svg>
            </div>
          </>
        </div>
      </section>
    </>
  );
}

export default WelcomeHeader;
